import React, { useEffect } from "react";
import { ToastProvider } from "react-toast-notifications";
import SnackbarProvider from "react-simple-snackbar";
import { BrowserRouter, Route, Switch } from "react-router-dom";
//style
import "./styles/App.scss";
//redux setup
import { Provider, useDispatch } from "react-redux";
import store from "./redux/store";
import { getNotes, relode } from "./redux/actions/AuthAction";
//pages
import SessionPage from "./pages/Learner/SessionPage";
import Dashboard from "./pages/Learner/Dashboard";
import ErrorPage from "./pages/404Page";
import EmailVerificationPage from "./pages/EmailVerificationErrror";
import Recording from "./pages/Recording";
import TeachwithUs from "./pages/TeachwithUs";
import UpgradePage from "./pages/UpgradePage";
import TransactionDetails from "./pages/TransactionDetails";
import DeleteLearnerUtil from "./components/DeleteLearnerUtil";
import CrmLogin from "./pages/Crm/CrmLogin";
import Register from "./pages/HomeSubscription/Register";
import Payment from "./pages/HomeSubscription/Payment"

//routes
import PublicRoute from "./Routes/PublicRoutes";
import LearnerRoute from "./Routes/LearnerRoute";
import LMS from "./Routes/LMS";
import VideoPlayer from "./pages/Learner/VideoPlayer";
import VideoPlayerRoute from "./Routes/VideoPlayerRoute";
import CrmRoute from "./Routes/CrmRoute"

import {
  currentPlan,
  FetchAllPlan,
  FetchAllPlanIELTS,
  FetchAllPlanKids,
  FetchTransaction,
} from "./redux/actions/PlanAction";
import {
  StudentUpcomingSession,
  StudentPastSession,
} from "./redux/actions/SessionAction";
import { GetLearner } from "./redux/actions/AuthAction";

import AccountNew from "./pages/Learner/AccountNew";
import LearnerWalletNew from "./pages/Learner/LearnerWalletNew";
import BookasessionNew from "./pages/BookasessionNew";
import SubscriptionHistory from "./pages/Learner/SubscriptionHistory";
import PlanAndPrices from "./pages/PlanAndPrices";
import {
  GetRefferalData,
  GetVideo,
  LearnerWalletHistory,
} from "./redux/actions/UserAction";
import Login from "./pages/Influencer/Login";
import InfluencerDashboard from "./pages/Influencer/Dashboard";
import EnglishAartBook from "./pages/EnglishAartBook";
import Affiliate from "./pages/AffiliatePage";
import EnglishAartBook2 from "./pages/EnglishArtBook2";
import AffiliateRoute from "./Routes/AffiliateRoute";

import MyVerticallyCenteredModal from "./pages/SpeakerProfileModal";
import FavoriteSpeakers from "./pages/Learner/FavoriteSpeakers";
import LoginFlow from "./pages/LoginFlow";
import PdfViewer from "./pages/Learner/PdfViewer";
import AuthRoute from "./Routes/AuthRoute";
import Crm from "./pages/Crm/Crm";
import HomepagePlans from "./pages/HomepagePlans";
import BookaDemo from "./pages/BookaDemo";
import HomePageRedesign from "./pages/HomePageRedesign";
import FbHomePageRedesign from "./pages/campaign/FbLandingPage";
import FbBookaDemo from "./pages/campaign/FbBookaDemo";
import GoogleHomePageRedesign from "./pages/campaign/GoogleLandingPage";
import GoogleBookaDemo from "./pages/campaign/GoogleBookaDemo";
import TestHardware from "./pages/TestHardware";
import ThankYouPage from "./pages/campaign/ThankYouPage";
import ThankYouPageGoogle from "./pages/campaign/ThankYouPageGoogle";
import ThankYouPageDigi from "./pages/campaign/ThankYouPageDigi";

import Referral from "./pages/Learner/Referral";
import IELTSLanding from "./pages/campaign/IELTSLanding";
import Course from "./pages/Course";
import Courses from "./pages/Courses";
import Success from "./pages/HomeSubscription/Success";
import ThankYouPage199 from "./pages/campaign/ThankYouPage199";
import SuccessMessage from "./components/BookDemo/thankyouPage199/SuccessMessage";
import ThankYouPageUAE from "./pages/campaign/ThankYouPageUAE";
import SuccessMessageUAE from "./components/BookDemo/thankyouPageUAE/SuccessMessage";
import ThankYouPage199Google from "./pages/campaign/ThankYouPage199Google";
import SuccessMessage199Google from "./components/BookDemo/thankyouPage199Google/SuccessMessage";
import IELTSNewLanding from "./pages/campaign/IELTSNewLanding";
import SuccessMessageIELTSNewLanding from "./components/BookDemo/IELTSNewLanding/SuccessMessageIELTSNewLanding";
const Routes = () => {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("USER"));
  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));

  useEffect(() => {

    dispatch(FetchAllPlanKids());
    dispatch(FetchAllPlanIELTS());
    dispatch(FetchAllPlan());
    if (user) {
      dispatch(relode(user));
      dispatch(currentPlan({ learnerId: user._id }));
      dispatch(
        StudentPastSession({
          studentID: user._id,
          page: 1,
          limit: 10,
          timezone: time_zone.timezone,
        })
      );
      dispatch(
        StudentUpcomingSession({
          studentID: user._id,
          page: 1,
          limit: 10,
          timezone: time_zone.timezone,
        })
      );
      dispatch(GetLearner({ learnerId: user._id }));
      dispatch(getNotes({ learner: user._id }));
      dispatch(FetchTransaction());
      dispatch(GetVideo());
      dispatch(GetRefferalData({ learnerId: user._id }));
      dispatch(LearnerWalletHistory({ learnerId: user._id }));
    }
  }, [user]);

  useEffect(() => {
    const token =
      "c_wFmsEtC-R16KaEwovj2g:APA91bES6QdFepw-KG3ZA92xbfrdu-jeucsvLDK4ZIZ0y4juBJTFsQu3CQnhbFF1IIQalZVHSqUj6FrLz0R423RNOZTdopQP-bhXYZG5mYqoeclwnyct_Gxi7OondVmYBDJ3liGQGyvB";
    localStorage.setItem("NOTIFICATION", JSON.stringify(token));

    fetch(`${process.env.REACT_APP_BASE_URL}/api/images`, {
      method: "get",
      headers: {
        "Access-Control-Allow-Origin":"*",
        "Content-Type": "application/json"
      }
    }).then((res) => res.json()).then(res=>{

      var data = {
        bookingLag:res.bookingLag,
        cancellationLag:res.cancellationTimeLimit
      }
      localStorage.setItem("SETUP", JSON.stringify(data));
    }); 

    

    if(time_zone.country !== "IN"){
      //'https://data.fixer.io/api/latest?access_key=b519d67e3cfca649d9681eec3ecab3b4&&base=USD'
          fetch('https://free.currconv.com/api/v7/convert?q=USD_INR&compact=ultra&apiKey=d4d9caef95acd44a4044')
          .then(response => response.json())
          .then(data => {
            localStorage.setItem("CURRENCY", JSON.stringify(data.USD_INR));
          }).catch(err=>{
            localStorage.setItem("CURRENCY", JSON.stringify("75"));
          });
        }else{
          localStorage.removeItem("CURRENCY")
        }

  }, []);

  return (
    <BrowserRouter>
      <Switch>
        <PublicRoute exact path="/" component={HomePageRedesign} />
        <PublicRoute exact path="/home" component={HomePageRedesign} />
        <PublicRoute exact path="/login" component={LoginFlow} />
        <Route exact path="/home-subscription" component={Register} />
        <Route exact path="/home-subscription/payment" component={Payment} />
        <Route exact path="/home-subscription/success" component={Success} />

        <Route exact path="/book-demo/:component" component={BookaDemo} />
        <Route exact path="/ielts" component={IELTSLanding} />
        <PublicRoute exact path="/fb" component={FbHomePageRedesign} />
        <Route exact path="/fb/book-demo/:component" component={FbBookaDemo} />
 
        <PublicRoute exact path="/google" component={GoogleHomePageRedesign} />
        <Route exact path="/google/book-demo/:component" component={GoogleBookaDemo} />

        <Route exact path="/thankyou/book-demo/:component" component={ThankYouPage} />
        <Route exact path="/thankyou/google/book-demo/:component" component={ThankYouPageGoogle} />
        <Route exact path="/thankyou/digi/book-demo/:component" component={ThankYouPageDigi} />
        <Route exact path="/thankyou/ielts/book-demo/:component" component={IELTSNewLanding} />
        <Route exact path="/thankyou/ielts/book-demo/success" component={SuccessMessageIELTSNewLanding} />

        <Route exact path="/adult-spoken199-fb" component={ThankYouPage199} />
        <Route exact path="/adult-spoken199-fb/book-demo/success" component={SuccessMessage} />
        <Route exact path="/adult-spoken-fb-uae" component={ThankYouPageUAE} />
        <Route exact path="/adult-spoken-fb-uae/book-demo/success" component={SuccessMessageUAE} />
        <Route exact path="/adult-spoken199-google" component={ThankYouPage199Google} />
        <Route exact path="/adult-spoken199-google/book-demo/success" component={SuccessMessage199Google} />

        <PublicRoute exact path="/home/:id" component={HomePageRedesign} />
        <PublicRoute exact path="/homenew" component={HomePageRedesign} />
        <PublicRoute exact path="/teach-with-us" component={TeachwithUs} />
        <PublicRoute exact path="/plans" component={HomepagePlans} />

        <CrmRoute exact path="/crm/login" component={CrmLogin} />
        <CrmRoute exact path="/crm/dashboard" component={Crm} />
        

        <AffiliateRoute exact path="/affiliate" component={Affiliate} />
        
        <Route exact path="/verification-error" component={EmailVerificationPage} />
        <VideoPlayerRoute path="/recordings" component={Recording} />
        {/* STUDENT */}
        <LearnerRoute exact path="/dashboard" component={Dashboard} />
        <LearnerRoute
          exact
          path="/student/planandprice"
          component={PlanAndPrices}
        />
        <LearnerRoute exact path="/upcoming_session" component={SessionPage} />
        <LMS exact path="/course" component={Course} />
        <LMS exact path="/courses" component={Courses} />
        <LearnerRoute exact path="/document" component={PdfViewer} />
        <LearnerRoute exact path="/student/session/recording" component={VideoPlayer} />
        <LearnerRoute exact path="/my_account" component={AccountNew} />
        <LearnerRoute exact path="/my_profile" component={AccountNew} />
        <LearnerRoute
          exact
          path="/student/wallet"
          component={LearnerWalletNew}
        />
        <LearnerRoute exact path="/bookasession" component={BookasessionNew} />
        <LearnerRoute
          exact
          path="/subscriptionHistory"
          component={SubscriptionHistory}
        />
        <LearnerRoute exact path="/upgradePlan" component={UpgradePage} />
        <LearnerRoute
          exact
          path="/transactionDetails"
          component={TransactionDetails}
        />

        <LearnerRoute
          exact
          path="/referral"
          component={Referral}
        />

       {/* <LearnerRoute
          exact
          path="/speaker-profiles"
          component={SpeakerProfileModal}
        /> */}
        
        <LearnerRoute
          exact
          path="/favorite-speaker"
          component={FavoriteSpeakers}
        />

        <LearnerRoute exact path="/test-hardware" component={TestHardware} />

        <AffiliateRoute exact path="/affiliate/login" component={Login} />
        <Route
          exact
          path="/affiliate/dashboard"
          component={InfluencerDashboard}
        />
        {process.env.REACT_APP_IS_DEV==="true"?
          // Delete Learner route will only be rendered in development mode
          <Route exact path="/deleteLearner" component={DeleteLearnerUtil} />
        :
          ""
        }
        <Route exact path="*" component={ErrorPage} />
      </Switch>
    </BrowserRouter>
  );
};

function App() {
  return (
    <SnackbarProvider>
      <ToastProvider>
        <Provider store={store}>
          <Routes />
        </Provider>
      </ToastProvider>
    </SnackbarProvider>
  );
}

export default App;
